import { UserListCard, UserListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/components'
import { SystemUserModifyModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/modals/system-user-modify-modal'
import { NoResultsAddCard } from '@apps-common/components/common'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IMMSiteModel } from '@apps-common/types/my-monitoring'
import { IUnitNamedUserCompleteModel } from '@apps-common/types/portal/users'
import { useIonModal } from '@ionic/react'
import { motion } from 'framer-motion'

interface IProps {
  loading: boolean
  site?: IMMSiteModel
  data?: IUnitNamedUserCompleteModel[]
  disabled?: boolean
}

export const SiteSystemUsers: React.FC<IProps> = ({ loading, site, data, disabled }) => {
  const [present, dismiss] = useIonModal(SystemUserModifyModal, {
    componentProps: {
      unit: {
        unitId: site?.unitId,
        ipAddress: site?.ipAddress
      }
    },
    onDismiss: (data: string, role: string) => dismiss(data, role),
    enableBackdropDismiss: true
  })

  loading = loading || !site || !data

  return (
    <div className='grid lg:grid-cols-2 gap-6'>
      {loading && Array.from(Array(4).keys()).map((k) => <UserListCardSkeleton key={`system-user-list-card-skeleton-${k}`} />)}
      {!loading &&
        data?.map((u, i) => (
          <motion.div key={`unit-system-named-user-${u.unitNamedUserId}`} {...motionFadeIn(0.25)}>
            <UserListCard
              index={i}
              type='system'
              unitId={site?.unitId!}
              ipAddress={site?.ipAddress!}
              userId={u.unitNamedUserId}
              profileImage={u.profileImage}
              name={`${u.firstName} ${u.lastName}`}
              zone={u.zone}
              partition={u.partition}
              disabled={disabled}
            />
          </motion.div>
        ))}
      {!loading && data?.length === 0 && (
        <NoResultsAddCard
          title='Nothing to see here.'
          message='This site has no system users'
          callback={() =>
            present({
              enterAnimation: modalSlideUpEnterAnimation,
              leaveAnimation: modalSlideUpLeaveAnimation
            })
          }
          disabled={loading || disabled || false}
        />
      )}
    </div>
  )
}
